// Modules
import styled from 'styled-components'

export const ContainerGlobal = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    height: 100dvh;
    background-color: #0037ff;
`

export const Container = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 100%;
`

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    max-width: 26.5rem;
    padding: 0 1rem;
    color: #fff;

    & > h1 {
        text-align: center;
    }

    .title {
        margin-bottom: 1.5rem;
        font-weight: 700;
        font-size: 2.2rem;
        line-height: 3rem;
    }
`

export const Illustration = styled.img`
    margin: 0 0 2.5rem 0;
    max-width: 26.5rem;
`
